import React from 'react'
import './myProfile.css'
import { dobToAge, sunSign, hobbiesWithIcons } from '../../utilities/utilities'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import key from '../../key'

const MyProfile = () => {
  //eslint-disable-next-line
  const { user } = useSelector((state) => state.user);
  const hobbies = hobbiesWithIcons(user?.personalDetails.interests.hobbies);

  return (
    <div className='container backgroundLight myProfile'>
      <div className='namee backgroundGrey'>
        {user?.firstName} {user?.lastName} <span>({user?.userId})</span>
      </div>
      <div className="row mt-3">
        <div className="col-md-2">
          <div className="profileImage">
            {
              user?.photos[0] ? (
                <img src={`${key}/images/${user?.photos[0].url}`} alt="Avatar" className="avatar" />
              ) : (
                <img src="https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png" alt="Avatar" className="avatar" />
              )
            }
          </div>
        </div>
        <div className="col-md-10">
          <div className="row d-flex justify-content-between mt-3">
            <div className="col-md-4">
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Age/Height:</div>
                <div>{`${dobToAge(user?.personalDetails.dob)} / ${user?.personalDetails.height}`}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Marital Status: </div>
                <div>{user?.personalDetails?.maritalStatus ? (
                  user?.personalDetails?.maritalStatus
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Looking for</div>
                <div>{user?.lookingFor ? (
                  user?.lookingFor
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Body Type</div>
                <div>{user?.personalDetails?.bodyType ? (
                  user?.personalDetails?.bodyType
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
              </div>
            </div>
            <div className="col-md-6 borderLeft">
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Religion / Community: </div>
                <div>{`${user?.personalDetails.religion}, ${user?.personalDetails.community}`}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Location Country: </div>
                <div>{user?.personalDetails?.countryLiving ? (
                  user?.personalDetails?.countryLiving
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>

              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Location City: </div>
                <div>{user?.personalDetails?.cityLiving ? (
                  user?.personalDetails?.cityLiving
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>

              </div>
              <div className='d-flex justify-content-between'>
                <div style={{ color: "grey" }}>Mother Tounge: </div>
                <div>{user?.personalDetails?.motherTongue ? (
                  user?.personalDetails?.motherTongue
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
              </div>
            </div>
          </div>
          <div className='bottomBorder'></div>
          <div className='bottomPart'>
            <div className='title'>Manage Your Profile</div>
            <div className="row">
              <div className="col-md-4">
                <ul className="custom-list">
                  <li className="custom-list-item">
                    <Link to="/edit-personal-profile">Edit Personal Profile</Link>
                  </li>
                  <li className="custom-list-item">
                    <Link to="/partnerpreferences">Edit Partner's Profile</Link>
                  </li>
                  <li className="custom-list-item">
                    <Link to="/edit-personal-profile">Edit WhatsApp Number</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className="custom-list">
                  <li className="custom-list-item">
                    <Link to="/">View Profile Stats</Link>
                  </li>
                  <li className="custom-list-item">
                    <Link to="/myphotos">Add Photos</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className="custom-list">
                  <li className="custom-list-item">
                    <Link to="/settings">Set Contact Privacy</Link>
                  </li>
                  <li className="custom-list-item">
                    <Link to="/settings">Hide/Delete Profile</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='bottomBorderSelf'></div>
      <button className='aboutMeBtn'>About Myself</button>
      <a className='partnerBtn' href="#partner">Partner Preference</a>

      <div className='title aboutHeading' >Personality, Family Details, Career, Partner Expectations etc.</div>
      <div className='aboutMe'>{user?.personalDetails?.aboutMe ? (
                  user?.personalDetails?.aboutMe
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
      <div className='title aboutHeading' >Basics & Lifestyle</div>
      <div>
        <div className="row d-flex justify-content-between mt-3">
          <div className="col-md-4">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Age:</div>
              <div>{`${dobToAge(user?.personalDetails.dob)}`}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Date of Birth</div>
              <div>{user?.personalDetails.dob}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Marital Status: </div>
              <div>{user?.personalDetails?.maritalStatus ? (
                  user?.personalDetails?.maritalStatus
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Height: </div>
              <div>{user?.personalDetails?.height ? (
                  user?.personalDetails?.height
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Grew Up in: </div>
              <div>{user?.personalDetails?.grewUpIn ? (
                  user?.personalDetails?.grewUpIn
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>

            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>State Living: </div>
              <div>{user?.personalDetails?.stateLiving ? (
                  user?.personalDetails?.stateLiving
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Residency Status: </div>
              <div>{user?.personalDetails?.residencyStatus ? (
                  user?.personalDetails?.residencyStatus
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>

          </div>
          <div className="col-md-6 borderLeft">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Diet: </div>
              <div>{user?.personalDetails?.diet ? (
                  user?.personalDetails?.diet
                ) : (
                  <Link to="/edit-personal-profile">Enter Now</Link>
                )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Personal Values: </div>
              <div>Will Tell you Later</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Sun Sign: </div>
              <div>{sunSign(user?.personalDetails.dob)}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Blood Group: </div>
              <div>{user?.personalDetails.bloodGroup ? (
                user?.personalDetails.bloodGroup
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Health Information: </div>
              <div>{user?.personalDetails?.healthInfo ? (
                user?.personalDetails?.healthInfo
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Disability: </div>
              <div>{user?.personalDetails?.disability ? (
                user?.personalDetails?.disability
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>

      <div className='title aboutHeading' >Religious Background</div>
      <div>
        <div className="row d-flex justify-content-between mt-3">
          <div className="col-md-4">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Religion :</div>
              <div>{user?.personalDetails.religion}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Community</div>
              <div>{user?.personalDetails.community}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Sub Community: </div>
              <div>{user?.personalDetails.subCommunity ? (
                user?.personalDetails.subCommunity
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Mother Tongue: </div>
              <div>{user?.personalDetails.motherTongue ? (
                user?.personalDetails.motherTongue
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>



      <div className='title aboutHeading' >Family details</div>
      <div>
        <div className="row d-flex justify-content-between mt-3">
          <div className="col-md-4">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Father's Status:</div>
              <div>{user?.familyDetails.fatherStatus ? (
                user?.familyDetails.fatherStatus
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Mother's Status</div>
              <div>{user?.familyDetails.motherStatus ? (
                user?.familyDetails.motherStatus
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Family Location: </div>
              <div>{user?.familyDetails.familyLocation ? (
                user?.familyDetails.familyLocation
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>

          </div>
          <div className="col-md-6 borderLeft">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>No. of Brothers: </div>
              <div>{user?.familyDetails.brothers ? (
                user?.familyDetails.brothers
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>No. of Sisters: </div>
              <div>{user?.familyDetails.sisters ? (
                user?.familyDetails.sisters
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Family Type: </div>
              <div>{user?.familyDetails.familyType ? (
                user?.familyDetails.familyType
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Family Values: </div>
              <div>{user?.familyDetails.familyValues ? (
                user?.familyDetails.familyValues
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Family Affluence: </div>
              <div>{user?.familyDetails.familyAffluence ? (
                user?.familyDetails?.familyAffluence
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>

      <div className='title aboutHeading' >Education & Career</div>
      <div>
        <div className="row d-flex justify-content-between mt-3">
          <div className="col-md-4">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Highest Qualification:</div>
              <div>{user?.educationAndCareer.qualification ? (
                user?.educationAndCareer.qualification
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>College Attended</div>
              <div>{user?.educationAndCareer.college ? (
                user?.educationAndCareer.college
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Annual Inocme: </div>
              <div>{user?.educationAndCareer.annualIncome ? (
                user?.educationAndCareer.annualIncome
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
          </div>

          <div className="col-md-6 borderLeft">
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Working With: </div>
              <div>{user?.educationAndCareer.workingWith ? (
                user?.educationAndCareer.workingWith
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Working as: </div>
              <div>{user?.educationAndCareer.occupation ? (
                user?.educationAndCareer.occupation
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
            <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>Employer Name: </div>
              <div>{user?.educationAndCareer.company ? (
                user?.educationAndCareer.company
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>
      <div className='title aboutHeading' >Hobbies and Interests</div>
      <div>{hobbies ? (
                hobbies.map((hobby, index) => {
                  return (
                    <div key={index} className='badgTags'>
                      {hobby.icon} {hobby.value}
                    </div>
                  )
                }
                )
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
      <div className='bottomBorder'></div>

      <div id="partner" className="backgroundGrey preference">
        Partner Preferences
      </div>

      <div className='title aboutHeading'>Basic Information</div>
      <div className="row d-flex justify-content-between">
        <div className="col-md-4">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Age:</div>
            <div>{user?.partnerPreferences.age ? (
                user?.partnerPreferences.age
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} years</div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Height:</div>
            <div>{user?.partnerPreferences.height ? (
                user?.partnerPreferences.height
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Marital Status: </div>
            <div>{user?.partnerPreferences.maritalStatus[0] ? (
                `${user?.partnerPreferences.maritalStatus},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
        </div>
        <div className="col-md-6 borderLeft">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Religion / Community: </div>
            <div>{`${user?.partnerPreferences.religion}/ ${user?.partnerPreferences.community}`}</div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Mother Tounge: </div>
            <div>{user?.partnerPreferences.motherTongue[0] ? (
                `${user?.partnerPreferences.motherTongue},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Diet: </div>
            <div>{user?.partnerPreferences.diet ? (
                `${user?.partnerPreferences.diet},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>

      <div className='title aboutHeading'>Location Details</div>
      <div className="row d-flex justify-content-between">
        <div className="col-md-4">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Country living in:</div>
            <div>{user?.partnerPreferences.countryLiving[0] ? (
                `${user?.partnerPreferences.countryLiving},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>City Living:</div>
            <div>{user?.partnerPreferences.cityLiving[0] ? (
                `${user?.partnerPreferences.cityLiving},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>City Grew Up In:</div>
            <div>{user?.partnerPreferences.grewUpIn[0] ? (
                `${user?.partnerPreferences.grewUpIn},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>

      <div className='title aboutHeading'>Education & Career</div>
      <div className="row d-flex justify-content-between">
        <div className="col-md-4">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Education:</div>
            <div>{user?.partnerPreferences.qualification[0] ? (
                `${user?.partnerPreferences.qualification},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>workingWith:</div>
            <div>{user?.partnerPreferences.workingWith[0] ? (
              `${user?.partnerPreferences.workingWith},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Profession: </div>
            <div>{user?.partnerPreferences.occupation[0] ? (
                `${user?.partnerPreferences.occupation},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
        </div>
        <div className="col-md-6 borderLeft">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Annual Income: </div>
            <div>{user?.partnerPreferences.annualIncome[0] ? (
              `${user?.partnerPreferences.annualIncome},`
              ) : (
                <Link to="/partnerpreferences">Enter Now</Link>
              )} </div>
          </div>
        </div>
      </div>
      <div className='bottomBorder'></div>

      <div className="backgroundGrey preference">
        My Contact Details
      </div>
      <div className='bottomBorder'></div>
      <div className="row d-flex justify-content-between m-3">
        <div className="col-md-4">
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Mobile:</div>
            <div>{user?.mobile}</div>
          </div>
          <div className='d-flex justify-content-between'>
            <div style={{ color: "grey" }}>Email</div>
            <div>{user?.email}</div>
          </div>
          <div className='d-flex justify-content-between'>
              <div style={{ color: "grey" }}>WhatsApp number: </div>
              <div>{user?.whatsApp ? (
                user?.whatsApp
              ) : (
                <Link to="/edit-personal-profile">Enter Now</Link>
              )}</div>
            </div>
        </div>
      </div>
      <div className='bottomBorder'></div>
    </div>
  )
}

export default MyProfile
